// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"d9de4f03","203":"653891ec","304":"66f7d00e","343":"358f279a","381":"3ec9b048","528":"aefa8dc0","548":"9b984160","569":"48027545","600":"0d828737","643":"dd88db7d","715":"0bc6f9e9","852":"905eb1a6","938":"6300256d"}[chunkId] + ".chunk.js";
};